import { connect } from "react-redux";
import { setLocale } from "../../base/userActions";
import NavigationBar from "../presentation/NavigationBar";
import { restoreSession } from "../userActions";

const mapStateToProps = (state) => {
  return {
    user: state.user,
    locale: state.user.locale,
    timelineQuery: state.settings.chartState,
    logo: null,
  };
};

const mapDispatchToProps = {
  setLocale,
  restoreSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
